module.exports = "https://www.gc-pro.gnp.com.mx/3cb8181b71ed3a7f53c03f6359f1e6c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/flecha-abajo-blanca.svg
// module id = 8109
// module chunks = 0